import React from "react";
import { UswfInput } from "./UswfInput";
import { InputAdornment } from "@mui/material";
import { getPercentInputValue } from "../util/forms/getPercentInputValue";

export const PercentInput = ({ value, price, onChange, ...other }) => {
  return (
    <UswfInput
      {...other}
      value={getPercentInputValue(value, price)}
      className="percent-input"
      onChange={(event) => {
        let percent = event.target.value;
        if (percent > 99) {
          percent = 99;
        }
        const newPercent = percent / 100;
        const newPrice = Math.round(newPercent * price);
        const newEvent = {
          ...event,
          target: {
            ...event.target,
            value: newPrice,
            name: event.target.name,
          },
        };
        onChange(newEvent);
      }}
      onFocus={(e) => {
        e.target.select();
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment
            className="date-picker-icon-mobile-wrapper"
            position="end"
          >
            %
          </InputAdornment>
        ),
      }}
    />
  );
};
